"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_DAYS_FOR_REPETITION = void 0;
exports.createTermine = createTermine;
var _facades = require("../facades");
var MAX_DAYS_FOR_REPETITION = exports.MAX_DAYS_FOR_REPETITION = 7;
function createTermine(selectedTerminStartDate, selectedTerminEndDate, repetitionInterval, repetitionEndDate) {
  var addDaysFromStart = (0, _facades.differenceInDays)((0, _facades.startOfDay)(selectedTerminEndDate), (0, _facades.startOfDay)(selectedTerminStartDate));
  var terminDuration = 1 + addDaysFromStart;
  if (repetitionInterval === 0 || terminDuration > repetitionInterval) {
    return [{
      start: selectedTerminStartDate,
      end: selectedTerminEndDate
    }];
  }
  return (0, _facades.eachDayOfInterval)({
    start: (0, _facades.startOfDay)(selectedTerminStartDate),
    end: (0, _facades.startOfDay)(repetitionEndDate)
  }, {
    step: repetitionInterval
  }).map(function (date) {
    return {
      start: date,
      end: (0, _facades.addDays)(date, addDaysFromStart)
    };
  });
}